import { Pane, Heading, Paragraph, UnorderedList, ListItem, Text, Table, Link, Alert } from 'evergreen-ui';

const InformativaCollaboratoriPage = () => {
  return (
    <Pane maxWidth={900} marginX="auto" padding={32}>

      <Heading size={900} marginBottom={8}>
        Informativa sul trattamento dei dati personali dei Collaboratori
      </Heading>
      <Paragraph size={300} color="muted" marginBottom={8}>
        Ai sensi dell'art. 13 del Regolamento (UE) 2016/679 (GDPR) — Versione 2.1 del 30/06/2026
      </Paragraph>
      <Paragraph size={300} color="muted" marginBottom={32}>
        Destinatari: collaboratori, educatori, operatori e personale dipendente o parasubordinato
        di Casa Letizia GAAG.
      </Paragraph>

      <Alert intent="warning" title="Trattamento di dati giudiziari e sanitari" marginBottom={32}>
        La presente informativa include il trattamento di dati giudiziari (casellario giudiziale,
        art. 10 GDPR) e di dati sanitari (certificati di malattia, art. 9 GDPR). Tali dati sono
        trattati esclusivamente in presenza di obblighi di legge e con le necessarie misure di
        sicurezza.
      </Alert>

      {/* ------------------------------------------------------------------ */}
      {/* 1. TITOLARE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>1. Titolare del trattamento</Heading>
      <Paragraph size={400} marginBottom={4}>
        <strong>Casa Letizia GAAG</strong> (Gruppo Appartamento Adolescenti e Giovani)
      </Paragraph>
      <Paragraph size={400} marginBottom={4}>Via Vandalino 25, 10093 Collegno (TO) — Italia</Paragraph>
      <Paragraph size={400} marginBottom={4}>Codice Fiscale / P.IVA: 13037730010</Paragraph>
      <Paragraph size={400} marginBottom={32}>
        E-mail: <Link href="mailto:dvessio7@hotmail.com">dvessio7@hotmail.com</Link>
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 2. CATEGORIE DI DATI */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>2. Categorie di dati personali trattati</Heading>

      <Heading size={500} marginBottom={8}>2.1 Dati identificativi e anagrafici (dati comuni)</Heading>
      <UnorderedList marginBottom={16}>
        <ListItem>Nome, cognome, data e luogo di nascita, codice fiscale;</ListItem>
        <ListItem>Indirizzo di residenza e/o domicilio, numero di telefono personale, e-mail personale;</ListItem>
        <ListItem>Copia del documento di identità e della tessera sanitaria;</ListItem>
        <ListItem>Dati del conto corrente (IBAN e intestatario) per l'erogazione delle retribuzioni;</ListItem>
        <ListItem>Dati del recapito di emergenza (nome, relazione, telefono).</ListItem>
      </UnorderedList>

      <Heading size={500} marginBottom={8}>2.2 Dati relativi al rapporto di lavoro</Heading>
      <UnorderedList marginBottom={16}>
        <ListItem>Tipo di contratto (dipendente, collaboratore, co.co.co., ecc.) e data di assunzione;</ListItem>
        <ListItem>Mansione, sede di lavoro, inquadramento contrattuale;</ListItem>
        <ListItem>Orario di lavoro contrattuale, ore mensili e giornaliere previste;</ListItem>
        <ListItem>Dati relativi a presenze, assenze, ferie, permessi, straordinari e timbrature;</ListItem>
        <ListItem>Turni di lavoro programmati (data, orario, periodo giorno/notte) e turni di reperibilità (data, fascia oraria, periodo ☀/☾, eventuali note);</ListItem>
        <ListItem><strong>Documenti retributivi in formato digitale</strong> — buste paga e bonifici stipendiali caricati dal direttore nel sistema gestionale; la presa visione da parte del collaboratore è registrata in modo immutabile;</ListItem>
        <ListItem>Flag di <strong>livello avanzato</strong> — indica se al collaboratore è stato concesso dal direttore un accesso ampliato al sistema gestionale (accesso alle funzioni normalmente riservate alla direzione); viene annotato nel fascicolo del personale;</ListItem>
        <ListItem>Flag di <strong>vista ristretta</strong> — indica se al collaboratore è stata applicata una limitazione di accesso che consente la visualizzazione dei soli propri turni e nasconde il diario condiviso; viene impostato dal direttore per esigenze organizzative interne;</ListItem>
        <ListItem>Dati relativi alla fine del rapporto di lavoro (data termine, motivo, ecc.).</ListItem>
      </UnorderedList>

      <Heading size={500} marginBottom={8}>
        2.3 Categorie particolari di dati — art. 9 GDPR (dati sanitari)
      </Heading>
      <UnorderedList marginBottom={16}>
        <ListItem>
          <strong>Certificati di malattia e dati sanitari</strong> — comunicati dal collaboratore
          per giustificare le assenze per malattia; trattati nei limiti previsti dalla normativa
          sul lavoro (D.Lgs. 81/2008 e CCNL applicabile).
        </ListItem>
        <ListItem>
          <strong>Dati per la sorveglianza sanitaria</strong> — cartelle sanitarie redatte dal
          medico competente, giudizi di idoneità alla mansione specifica (D.Lgs. 81/2008). Il
          medico competente opera come titolare autonomo del trattamento.
        </ListItem>
      </UnorderedList>

      <Heading size={500} marginBottom={8}>
        2.4 Dati giudiziari — art. 10 GDPR (casellario giudiziale)
      </Heading>
      <Paragraph size={400} marginBottom={8}>
        Casa Letizia GAAG è tenuta per legge a verificare che il personale a contatto con i
        minori non abbia precedenti penali per reati specifici (D.Lgs. 39/2014, attuativo
        della Direttiva 2011/93/UE). A tal fine:
      </Paragraph>
      <UnorderedList marginBottom={32}>
        <ListItem>
          Prima dell'inizio del rapporto di lavoro o collaborazione, il collaboratore è tenuto
          a presentare il <strong>certificato del casellario giudiziale generale</strong> per
          verificare l'assenza di condanne per i reati di cui agli artt. 600-bis, 600-ter,
          600-quater, 600-quinquies, 609-undecies del Codice Penale e per i reati di cui al
          D.Lgs. 39/2014.
        </ListItem>
        <ListItem>
          Il certificato è <strong>verificato dalla direzione e non conservato</strong> nei
          sistemi informatici. Viene presa nota dell'avvenuta verifica e della data nel fascicolo
          del personale. Il documento originale viene restituito al collaboratore o distrutto
          in modo sicuro dopo la verifica.
        </ListItem>
        <ListItem>
          La verifica può essere ripetuta periodicamente o su richiesta degli enti committenti.
        </ListItem>
      </UnorderedList>

      {/* ------------------------------------------------------------------ */}
      {/* 3. FINALITÀ E BASI GIURIDICHE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>3. Finalità del trattamento e basi giuridiche</Heading>

      <Pane border="default" borderRadius={4} marginBottom={32} overflow="hidden">
        <Table>
          <Table.Head>
            <Table.TextHeaderCell>Finalità</Table.TextHeaderCell>
            <Table.TextHeaderCell>Base giuridica</Table.TextHeaderCell>
            <Table.TextHeaderCell>Riferimento normativo</Table.TextHeaderCell>
          </Table.Head>
          <Table.Body>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Stipula, gestione ed esecuzione del contratto di lavoro o collaborazione
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Art. 6.1.b GDPR — esecuzione del contratto</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Codice Civile artt. 2094 ss.; CCNL applicabile</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Gestione delle retribuzioni e pagamento degli stipendi (incluso trattamento IBAN)
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Art. 6.1.b GDPR — esecuzione del contratto</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>D.Lgs. 231/2002; D.P.R. 600/1973</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Adempimenti fiscali, previdenziali e assicurativi (comunicazioni a INPS, INAIL,
                Agenzia delle Entrate, CUD/CU, versamento contributi)
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Art. 6.1.c GDPR — adempimento di obblighi legali</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                D.P.R. 600/1973; D.P.R. 917/1986 (TUIR); D.Lgs. 509/1994; L. 335/1995
              </Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Gestione di presenze, assenze, ferie, permessi, turni e timbrature
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Art. 6.1.b GDPR — esecuzione del contratto + art. 6.1.c GDPR — obbligo legale
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>D.Lgs. 81/2008; D.Lgs. 66/2003 (orario di lavoro); CCNL</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Verifica del possesso dei requisiti legali per lavorare a contatto con i minori
                (certificato casellario giudiziale)
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Art. 6.1.c GDPR — obbligo legale + art. 10 GDPR (dati giudiziari in base a
                disposizione di legge)
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                D.Lgs. 39/2014 (attuazione Direttiva 2011/93/UE) — obbligo di verifica
                dell'assenza di condanne per reati sessuali su minori
              </Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Sicurezza e salute nei luoghi di lavoro (sorveglianza sanitaria, valutazione
                dei rischi)
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Art. 6.1.c GDPR + art. 9.2.b GDPR — diritto del lavoro e previdenza sociale
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>D.Lgs. 81/2008</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Gestione di eventuali contenziosi lavorativi
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Art. 6.1.f GDPR — legittimo interesse + art. 6.1.c GDPR
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Codice Civile; D.Lgs. 276/2003; normativa processualistica</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Gestione delle comunicazioni urgenti (emergenze, sostituzioni, sicurezza)
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Art. 6.1.d GDPR (interessi vitali) + art. 6.1.b GDPR
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Normativa generale; D.Lgs. 81/2008</Text></Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Pane>

      {/* ------------------------------------------------------------------ */}
      {/* 4. PERSONALE AUTORIZZATO */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>4. Personale autorizzato al trattamento</Heading>
      <Paragraph size={400} marginBottom={12}>
        I dati dei collaboratori sono accessibili esclusivamente al seguente personale, formalmente
        autorizzato al trattamento ai sensi dell'art. 29 GDPR:
      </Paragraph>
      <UnorderedList marginBottom={16}>
        <ListItem>
          <strong>Direttore</strong> — accesso completo a tutti i dati dei collaboratori:
          anagrafica, dati contrattuali, IBAN, presenze, fascicolo personale, storico turni,
          documenti retributivi; unico soggetto abilitato ad assegnare il livello avanzato.
        </ListItem>
        <ListItem>
          <strong>Consulente del lavoro / Studio di consulenza</strong> — per gli adempimenti
          retributivi, fiscali e previdenziali; nominato responsabile del trattamento ex art.
          28 GDPR.
        </ListItem>
        <ListItem>
          <strong>Istituto di credito</strong> — per l'esecuzione dei bonifici stipendiali,
          nei limiti strettamente necessari (IBAN, importo, causale).
        </ListItem>
      </UnorderedList>
      <Paragraph size={400} marginBottom={32}>
        Ciascun collaboratore ha accesso ai soli propri dati retributivi (buste paga e bonifici
        a lui intestati) tramite l'area riservata del sistema gestionale.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 5. DESTINATARI */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>5. Destinatari dei dati</Heading>
      <Paragraph size={400} marginBottom={12}>
        I dati personali dei collaboratori possono essere comunicati, nei limiti strettamente
        necessari e in presenza di idonea base giuridica, ai seguenti soggetti:
      </Paragraph>
      <UnorderedList marginBottom={32}>
        <ListItem>
          <strong>Istituto Nazionale della Previdenza Sociale (INPS)</strong> — per le
          comunicazioni obbligatorie relative al rapporto di lavoro, ai contributi e agli
          ammortizzatori sociali.
        </ListItem>
        <ListItem>
          <strong>Istituto Nazionale per l'Assicurazione contro gli Infortuni sul Lavoro (INAIL)</strong>{' '}
          — per le comunicazioni obbligatorie e la gestione degli infortuni.
        </ListItem>
        <ListItem>
          <strong>Agenzia delle Entrate</strong> — per gli adempimenti fiscali (CU, F24, ecc.).
        </ListItem>
        <ListItem>
          <strong>Consulente del lavoro / Studio di consulenza</strong> — quale responsabile
          del trattamento per la gestione delle buste paga, degli adempimenti previdenziali
          e fiscali.
        </ListItem>
        <ListItem>
          <strong>Istituto di credito</strong> — per l'esecuzione dei bonifici retributivi.
        </ListItem>
        <ListItem>
          <strong>Medico competente</strong> — per la sorveglianza sanitaria obbligatoria
          ai sensi del D.Lgs. 81/2008; il medico competente opera come titolare autonomo
          del trattamento.
        </ListItem>
        <ListItem>
          <strong>Fornitore del software gestionale</strong> — quale responsabile del
          trattamento per la fornitura e manutenzione del sistema informatico che gestisce
          presenze, turni e comunicazioni.
        </ListItem>
        <ListItem>
          <strong>Autorità e organi di controllo</strong> — Ispettorato del Lavoro, Guardia
          di Finanza, Autorità Giudiziaria — nei soli casi in cui la comunicazione sia
          obbligatoria per legge o richiesta da provvedimento.
        </ListItem>
      </UnorderedList>
      <Paragraph size={400} marginBottom={32}>
        I dati non vengono venduti, ceduti o comunicati a terzi per finalità commerciali.
        La diffusione dei dati è vietata, fatta eccezione per le comunicazioni obbligatorie
        previste dalla legge.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 6. TRASFERIMENTO EXTRA-UE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>6. Trasferimento verso paesi terzi</Heading>
      <Paragraph size={400} marginBottom={32}>
        I dati personali dei collaboratori non vengono trasferiti verso paesi terzi al di fuori
        dell'Unione Europea o dello Spazio Economico Europeo. Il server che ospita il sistema
        gestionale è ubicato in Italia o nell'Unione Europea.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 7. CONSERVAZIONE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>7. Periodo di conservazione</Heading>
      <Pane border="default" borderRadius={4} marginBottom={32} overflow="hidden">
        <Table>
          <Table.Head>
            <Table.TextHeaderCell>Categoria di dato</Table.TextHeaderCell>
            <Table.TextHeaderCell>Periodo di conservazione</Table.TextHeaderCell>
            <Table.TextHeaderCell>Base normativa</Table.TextHeaderCell>
          </Table.Head>
          <Table.Body>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Fascicolo personale (dati anagrafici, contratto, documenti)</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Durata del rapporto + 10 anni dalla cessazione</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>D.P.R. 600/1973; Codice Civile art. 2220</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Buste paga, dati retributivi, CU/CUD</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>10 anni dalla data del documento</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>D.P.R. 600/1973 art. 22 (obblighi di conservazione fiscale)</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Dati IBAN e bonifici retributivi</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>10 anni dall'ultima operazione</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>D.P.R. 600/1973; D.Lgs. 231/2007 (antiriciclaggio)</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Presenze, turni, ferie, timbrature</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                10 anni dalla data di registrazione (o dalla cessazione del rapporto se antecedente)
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>D.Lgs. 66/2003; D.P.R. 600/1973; CCNL</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Comunicazioni INPS, INAIL, dichiarazioni fiscali</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>10 anni</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>D.P.R. 600/1973; L. 335/1995</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Certificato casellario giudiziale (solo verifica, non conservazione del documento)
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Il documento originale non viene conservato. Viene registrata la data e l'esito
                della verifica nel fascicolo del personale per la durata del rapporto di lavoro.
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>D.Lgs. 39/2014; Linee guida Garante</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Dati sanitari (certificati malattia — escluse cartelle mediche)</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Durata del rapporto + 5 anni, o il termine di prescrizione dei diritti collegati
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>D.Lgs. 81/2008; D.Lgs. 196/2003</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Credenziali di accesso al sistema gestionale</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Revocate immediatamente al termine del rapporto di lavoro o collaborazione
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Art. 32 GDPR; principio di minimizzazione</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Log di accesso al sistema informativo</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>12 mesi</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Principio di minimizzazione GDPR</Text></Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Pane>

      {/* ------------------------------------------------------------------ */}
      {/* 8. MISURE DI SICUREZZA */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>8. Misure di sicurezza</Heading>
      <Paragraph size={400} marginBottom={12}>
        Casa Letizia GAAG adotta le seguenti misure di sicurezza tecniche e organizzative
        ai sensi dell'art. 32 GDPR:
      </Paragraph>
      <UnorderedList marginBottom={32}>
        <ListItem>
          <strong>Accesso autenticato</strong> — i dati dei collaboratori nell'area riservata
          sono accessibili solo tramite credenziali personali.
        </ListItem>
        <ListItem>
          <strong>Controllo degli accessi per ruoli</strong> — solo il direttore ha accesso
          ai dati contrattuali, retributivi e al fascicolo personale dei collaboratori.
        </ListItem>
        <ListItem>
          <strong>Trasmissione cifrata</strong> — protocollo HTTPS per tutte le comunicazioni.
        </ListItem>
        <ListItem>
          <strong>Password in hash crittografico</strong> — le password non sono mai conservate
          in chiaro.
        </ListItem>
        <ListItem>
          <strong>Revoca immediata delle credenziali</strong> — al termine del rapporto, le
          credenziali vengono revocate entro 24 ore.
        </ListItem>
        <ListItem>
          <strong>Procedura di gestione dei data breach</strong> — in caso di violazione dei
          dati, Casa Letizia GAAG notificherà il Garante entro 72 ore (art. 33 GDPR).
        </ListItem>
      </UnorderedList>

      {/* ------------------------------------------------------------------ */}
      {/* 9. DIRITTI */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>9. Diritti degli interessati</Heading>
      <Paragraph size={400} marginBottom={12}>
        In qualità di collaboratore, hai il diritto di esercitare in qualsiasi momento i
        seguenti diritti nei confronti del Titolare del trattamento, ai sensi degli artt.
        15-22 del GDPR:
      </Paragraph>
      <UnorderedList marginBottom={16}>
        <ListItem>
          <strong>Diritto di accesso (art. 15)</strong> — ottenere copia dei dati personali
          che ti riguardano conservati nel sistema.
        </ListItem>
        <ListItem>
          <strong>Diritto di rettifica (art. 16)</strong> — far correggere dati inesatti o
          far integrare dati incompleti (es. variazione dell'IBAN, aggiornamento dell'indirizzo).
        </ListItem>
        <ListItem>
          <strong>Diritto alla cancellazione (art. 17)</strong> — nei casi previsti dalla
          norma. Si precisa che per i dati soggetti a obblighi di conservazione fiscale,
          previdenziale o lavoristica, il diritto alla cancellazione è limitato per la durata
          dei relativi obblighi.
        </ListItem>
        <ListItem>
          <strong>Diritto di limitazione (art. 18)</strong> — nei casi previsti dalla norma.
        </ListItem>
        <ListItem>
          <strong>Diritto alla portabilità (art. 20)</strong> — ricevere i tuoi dati in
          formato strutturato, per i trattamenti basati su contratto e effettuati con mezzi
          automatizzati.
        </ListItem>
        <ListItem>
          <strong>Diritto di opposizione (art. 21)</strong> — per motivi connessi alla tua
          situazione particolare, nei casi in cui il trattamento sia basato su legittimo
          interesse. Non si applica ai trattamenti necessari per l'esecuzione del contratto
          o per adempimenti di legge.
        </ListItem>
      </UnorderedList>
      <Paragraph size={400} marginBottom={32}>
        Per esercitare i tuoi diritti contatta il Titolare all'indirizzo e-mail{' '}
        <Link href="mailto:dvessio7@hotmail.com">dvessio7@hotmail.com</Link> oppure per
        iscritto all'indirizzo della sede legale. Il Titolare risponderà entro 30 giorni
        dalla ricezione della richiesta.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 10. RECLAMO AL GARANTE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>10. Diritto di reclamo al Garante</Heading>
      <Paragraph size={400} marginBottom={12}>
        Hai il diritto di proporre reclamo al{' '}
        <strong>Garante per la protezione dei dati personali</strong>:
      </Paragraph>
      <UnorderedList marginBottom={32}>
        <ListItem>Piazza Venezia, 11 — 00187 Roma (RM)</ListItem>
        <ListItem>Centralino: +39 06 696771</ListItem>
        <ListItem>E-mail: <Link href="mailto:garante@gpdp.it">garante@gpdp.it</Link></ListItem>
        <ListItem>PEC: <Link href="mailto:protocollo@pec.gpdp.it">protocollo@pec.gpdp.it</Link></ListItem>
        <ListItem>
          Sito web:{' '}
          <Link href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">
            www.garanteprivacy.it
          </Link>
        </ListItem>
      </UnorderedList>

      {/* ------------------------------------------------------------------ */}
      {/* 11. OBBLIGATORIETÀ DEI DATI */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>11. Obbligatorietà della fornitura dei dati</Heading>
      <Paragraph size={400} marginBottom={32}>
        Il conferimento dei dati personali per le finalità connesse all'esecuzione del contratto
        di lavoro e agli adempimenti di legge (sezione 3) è obbligatorio. Il rifiuto di fornire
        tali dati renderebbe impossibile instaurare o proseguire il rapporto di lavoro o
        collaborazione. Il conferimento dei dati per finalità facoltative (ove previste) è
        invece libero, e il rifiuto non comporta conseguenze sul rapporto di lavoro.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* FOOTER */}
      {/* ------------------------------------------------------------------ */}
      <Pane borderTop="muted" paddingTop={16}>
        <Text size={300} color="muted">
          Versione 2.1 — Ultimo aggiornamento: 30 giugno 2026 | Base normativa: Reg. (UE)
          2016/679 (GDPR) artt. 9, 10, 13 — D.Lgs. 196/2003 — D.Lgs. 39/2014 — D.Lgs.
          81/2008 — D.P.R. 600/1973
        </Text>
      </Pane>
      <Pane marginTop={12}>
        <Text size={300} color="muted">
          Il fornitore del sito web non è responsabile della conformità legale dei contenuti
          di questa pagina, che è redatta e aggiornata a cura del Titolare del trattamento.
          Si raccomanda la validazione da parte di un professionista specializzato in GDPR.
        </Text>
      </Pane>

    </Pane>
  );
};

export default InformativaCollaboratoriPage;
